<template>
  <div class="" style="padding:10px">
    <kevideo :order="false" :list="list" />
    <div v-if="list.length == 0" style="text-align :center">没有更多的数据</div>
  </div>
</template>

<script>
/**
@description:课程列表
@createTime:2021-08-20
@create:wq
*/

import kevideo from "../../../components/kcvideo.vue";
// import {  List } from "vant";

export default {
  name: "",
  props: {},
  components: { kevideo },
  data() {
    return {
      active: 0,
      list: [],
      page: 1,
      loading: false,
      finished: false,
    };
  },
  computed: {},
  watch: {
    active() {
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.page = 1;
      // this.onLoad();
    },
  },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.getListmc();
    } else {
      this.getList();
    }
    this.page++;
  },
  methods: {
    getList() {
      this.api.teacherCurriculum().then((res) => {
        res.data.data.forEach((o) => (o.type = 1));
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    getListmc() {
      this.api.teacherCurriculumOrder().then((res) => {
        res.data.data.forEach((o) => (o.type = 1));
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    // onLoad() {
    //   this.getList();
    //   this.page++;
    // },
  },
};
</script>
<style lang="scss" scoped>
.list {
  margin: 0 0.22rem;
}
</style>
